/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { StandadCard } from "../../../../../components/Cards";
import {
  AccountCircle,
  AdminPanelSettings,
  StickyNote2,
  StickyNote2Outlined,
} from "@mui/icons-material";
import { TabPanel } from "../../../../../components/Tabs/TabPanel";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { fetchCustomerInfoAsync } from "../../../../../redux/businessPolicy/businessPolicyBasicDetails/businessPolicyBasicDetailsActions";
import { useDispatchWrapper, useQueryParms } from "../../../../../hooks";
import { TabsList } from "../../../../../components/Tabs/TabsList";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useBreadcrumbContext } from "../../../../../contexts/BreadcrumbProvider/BreadcrumbProvider";
import { CommAutomobileDriverInformationList } from "./CommAutoDriver/CommAutoDriverInformation/CommAutoDriverInformationList";
import { CommAutomobileDriverClaimsList } from "./CommAutoDriver/CommAutoDriverClaims/CommAutoDriverClaimsList";
import { CommAutomobileDriverConvictionList } from "./CommAutoDriver/CommAutoDriverConviction/CommAutoDriverConvictionList";
import { CommAutomobileDriverActivityList } from "./CommAutoDriver/CommAutoDriverActivity/CommAutoDriverActivityList";
import { fetchCommAutomobileCustomerInfoAsync } from "../../../../../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";

export const CommAutoDriverRoot: React.FC = () => {
 
  const data= useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const {addBreadcrumb} = useBreadcrumbContext();
  const {getParm} = useQueryParms();
  const tabValue = getParm('tab');
  const selectedTab = tabValue ? Number(tabValue) : 0;
  
  const { customerInfo } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );
  const navigate = useNavigate();
  

  const dispatch = useDispatchWrapper();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
   
    navigate(
      `/comm-automobile-policy/${customerId}/driver-tab/${customerPolicyId}?tab=${newValue}`
    );
  };

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  React.useEffect(()=>{
    addBreadcrumb({title: "", items:  [
      {
        to: "/dashboard",
        title: "dashboard",
      },
      {
        to: "/view-customers",
        title: "customers",
      },
      {
        to: "/customer-overview/" + customerId,
        title: "customer-overview",
      },
      {
        to: "/comm-automobile-policy/comm-automobile/" + customerId + "/" + customerPolicyId,
        title: "driver",
      },
    
    ]})
  },[])



  return (
    <PageLoader
      loading={customerInfo.loading === LoadState.InProgress}
      error={customerInfo.error ? { message: customerInfo.error } : null}
    >
      <StandadCard>
        <TabsList
          sx={{ mb: 1 }}
          varaint="fullWidth"
          selectedTab={selectedTab}
          tabs={[
            { label: "Driver Information", icon: <AccountCircle /> },
            {
              label: "Claims",
              icon: <AdminPanelSettings />,
            },
            {
              label: "Convictions",
              icon: <StickyNote2 />,
            },
            {
                label: "Insurance Reports",
                icon: <StickyNote2Outlined />,
            },
          ]}
          onChange={handleChange}
        />
        <TabPanel value={selectedTab} index={0}>
          <CommAutomobileDriverInformationList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <CommAutomobileDriverClaimsList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <CommAutomobileDriverConvictionList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={3}>
          <CommAutomobileDriverActivityList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
        </TabPanel>
      </StandadCard>
    </PageLoader>
  );
};
